module.exports = __webpack_public_path__ + "static/img/banner4.d0dcfb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner4.png
// module id = d5QM
// module chunks = 0